export const DISCHARGE_CRITERIA_FIELD_NAMES = [
  'mastery_of_program_goals',
  'titration_plan',
  'readiness_to_step_down',
  'care_coordination',
] as const;
